module.exports = __webpack_public_path__ + "static/img/pattiBlack38177Unsplash.69ca2a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/GreenIQ/pattiBlack38177Unsplash.png
// module id = m1Xk
// module chunks = 0